import { Col, Row, Input, Form, Select } from 'antd'
import styles from '../styles.module.scss'

const { Option } = Select

const UpdateUserInfo: React.FC = () => {
  return (
    <div className={styles.updateUser}>
      <Row>
        <Col>
          <div className="modalChild">
            <img src="https://www.gravatar.com/avatar/bbb8db824654275128ce09499cbbeff439840ae68f19f83861c243450dc1d6c7" />
            <Form layout="vertical" style={{ width: 340 }}>
              <Form.Item label="Usuario" name="user">
                <Input placeholder="Juan Perez" />
              </Form.Item>
              <Form.Item label="Telefono" name="phone">
                <Input type="password" placeholder="(333)56738734" />
              </Form.Item>
              <Form.Item label="email" name="email">
                <Input type="password" placeholder="john.doe@ex.com" />
              </Form.Item>
              <Form.Item name="gender" label="Gender">
                <Select>
                  <Option value="male">male</Option>
                  <Option value="female">female</Option>
                  <Option value="other">other</Option>
                </Select>
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default UpdateUserInfo
